import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query'
import { axiosGet } from '../logic/axios/wrappers/axios.get.wrapper'
import { getJobListingDetailUrl } from './config'
import type { JobListingDetail } from './job-listing.types'

export const getPublicJobAdDetailQueryKey = 'get-public-job-ad'

export const useGetPublicJobAdDetailQuery = (
  jobListingUuid: string,
  options?: Omit<
    UseQueryOptions<JobListingDetail, Error, JobListingDetail, string[]>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<JobListingDetail, Error> => {
  return useQuery({
    queryKey: [getPublicJobAdDetailQueryKey, jobListingUuid],
    queryFn: () =>
      axiosGet<JobListingDetail>(getJobListingDetailUrl(jobListingUuid)),
    enabled: !!jobListingUuid,
    ...options,
  })
}
